import classnames from 'classnames';
import type { ReactNode } from 'react';

import { css } from '@sorare/css';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';

import type { Props as HeaderProps } from './Header/index.tsx';
import { Header } from './Header/index.tsx';

type Props = HeaderProps & {
  noBorder?: boolean;
  children?: ReactNode;
};

const root = css`
  background-color: var(--c-surface-primary);
  border-radius: var(--double-unit);
  width: 100%;
  padding: var(--double-unit);
  &.noBorder {
    border-top: none;
  }
`;

export const SettingsSection = ({
  title,
  description,
  noBorder,
  children,
  toggleButton,
}: Props) => {
  return (
    <Vertical gap={2} className={classnames(root, { noBorder })}>
      <Header
        title={title}
        description={description}
        toggleButton={toggleButton}
      />
      {children}
    </Vertical>
  );
};
